import { render, staticRenderFns } from "./RsaPazienteSocioRiabilitativoProfiloSocialeEditComponent.vue?vue&type=template&id=03b05945"
import script from "./RsaPazienteSocioRiabilitativoProfiloSocialeEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSocioRiabilitativoProfiloSocialeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports